import { toast } from 'react-toastify';

// Universal Error Handler
export const showError = (message: string): void => {
  toast.error(message, {
    // position: toast.POSITION.TOP_RIGHT,
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
  });
};

// Universal Success Handler
export const showSuccess = (message: string): void => {
  toast.success(message, {
    // position: toast.POSITION.TOP_RIGHT,
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
  });
};
